import React, { useEffect, useState } from 'react'
import AsyncDropdown, { PropsWithAsyncDropdown } from 'core/elements/dropdown/AsyncDropdown'
import { getGpuModels } from 'openstack/components/infrastructure/blueprint/host-network-configs/helpers'

interface Props {}

export default function GpuPassthroughModelPicklist({
  name = 'gpuPassthroughModel',
  label = 'GPU Model',
  compact = false,
  ...rest
}: PropsWithAsyncDropdown<Props>) {
  const [options, setOptions] = useState([])
  useEffect(() => {
    const makeCalls = async () => {
      const gpuModels = await getGpuModels()
      const mappedOptions = gpuModels.map((model) => ({ label: model.model, value: model.name }))
      setOptions(mappedOptions)
    }
    makeCalls()
  }, [])

  return <AsyncDropdown compact={compact} name={name} label={label} items={options} {...rest} />
}
